import React from "react";
import { CircularProgress, Stack, Tooltip, Typography } from "@mui/material";

import { PatientMeetingData } from "../../../types";
import { formatDateLabel } from "./patient-meeting-date-format";

interface PatientMeetingSummaryTileProps {
  title: string;
  isLoading: boolean;
  meeting: PatientMeetingData | undefined;
  emptyLabel: string;
  onClick: (meeting: PatientMeetingData) => void;
}

const PatientMeetingSummaryTile: React.FC<PatientMeetingSummaryTileProps> = ({
  title,
  isLoading,
  meeting,
  emptyLabel,
  onClick,
}) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!meeting) {
      return;
    }

    event.stopPropagation();
    onClick(meeting);
  };

  return (
    <Tooltip title={title} placement="top">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        sx={{
          flex: 1,
          borderRadius: 1,
          p: 1,
          border: meeting ? "none" : "1px solid rgba(0,0,0,0.16)",
          cursor: meeting ? "pointer" : "default",
          transition: "all 0.2s ease-in-out",
          backgroundColor: meeting ? ((theme) => theme.palette.meetingStatus[meeting.meetingType]?.main) : "transparent",
          "&:hover": meeting
            ? {
              opacity: 0.92,
              transform: "translateY(-1px)",
            }
            : {},
        }}
        onClick={meeting ? handleClick : undefined}
      >
        {isLoading ? (
          <CircularProgress size={16} />
        ) : meeting ? (
          <Typography variant="body2" sx={{ fontWeight: 600, fontSize: "0.8rem", color: "#FFF" }}>
            {meeting.startTime ? formatDateLabel(meeting.startTime) : "No Date"}
          </Typography>
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem", fontWeight: 600 }}>
            {emptyLabel}
          </Typography>
        )}
      </Stack>
    </Tooltip>
  );
};

export default PatientMeetingSummaryTile;
